<template>
  <div class="container" style="padding-top: 5rem">
    <div class="account-box">
      <div class="account-wrapper">
        <h3 class="account-title">Change Password</h3>
        <hr />
        <div
          class="alert alert-danger text-justify px-2 py-2"
          style="font-size: 13px; word-spacing: -3px"
        >
          Password Requirement: <br />
          Must be minimum of 6 characters with combination of upper and lower
          case letters, numbers, and non-alphanumeric symbols
        </div>
        <form @submit.prevent="changePassword">
          <p
            class="text-danger text-center"
            style="word-spacing: -3px"
            v-if="errorMessage"
          >
            {{ errorMessage }}
          </p>
          <div class="form-group">
            <label>New Password</label>
            <input
              class="form-control"
              type="password"
              v-model="newPassword"
              maxlength="50"
              required
            />
          </div>
          <div class="form-group">
            <label>Confirm New Password</label>
            <input
              class="form-control"
              type="password"
              v-model="confirmNewPassword"
              maxlength="50"
              required
            />
          </div>
          <div class="form-group text-center">
            <button class="btn btn-primary account-btn" type="submit">
              Change Password
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
    
<script>
import API from "../../http-common.js";

export default {
  data() {
    return {
      errorMessage: "",
      newPassword: "",
      confirmNewPassword: "",
    };
  },

  methods: {
    changePassword() {
      this.errorMessage = "";
      if (this.newPassword !== this.confirmNewPassword) {
        this.errorMessage =
          "New Password and Confirm New Password do not match";
        return;
      }
      this.$store.state.isLoading = true;
      API.resetPassword({
        token: this.$route.params.token,
        new_password: this.newPassword,
      })
        .then((response) => {
          this.$store.state.isLoading = false;
          let success = response.data.success;
          if (success) {
            this.$store.state.changePasswordSuccess = true;
            this.$router.replace({ name: "merchantLogin" });
          } else {
            this.errorMessage = response.data.message;
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          console.log(error);
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
  },

  beforeRouteEnter(to, from, next) {
    API.verifyResetPasswordLink({
      token: to.params.token,
    })
      .then((response) => {
        if (!response.data.success) {
          return next({ name: "merchantLogin" });
        } else {
          return next();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Merchant/ResetPassword.vue